module.exports = __webpack_public_path__ + "img/main_home_phone_ru.17e06c1.png";